import { setDefaults, getRenderElement } from '@udecode/slate-plugins';
import linkElement from './element';

const renderElementLink = options => {
  const { link } = setDefaults(options, linkElement);

  return getRenderElement(link);
};

export default renderElementLink;
